
import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import util from './../../utils/utils';
import moment from "moment";
import { startFeatureEdit } from './featureEdit';
import { publishProduct } from './product';
import { updateDomainModal } from './domainModal';
import intl from 'react-intl-universal';
export const GET_FEATURES_LIST = "GET_FEATURES_LIST";
export const GET_COMMON_DOMAIN_LIST = "GET_COMMON_DOMAIN_LIST";
export const UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS";
export const RESETDATA = "RESETDATA";
export const SET_NEWCREATED = "SET_NEWCREATED";
export const SET_SINGLE_PARAMETER = "SET_SINGLE_PARAMETER";

moment.locale("zh-cn");

message.config({
  top: 300,
  maxCount: 3
});



export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_LOADING_STATUS,
      loading
    });
  };
}
// 重置功能点相关数据
export function resetData() {
  return (dispatch, getState) => {
    dispatch({
      type: RESETDATA,
    });
  }
}
// 设置是否首次添加产品
export function setNewCreated({ newCreated }) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_NEWCREATED,
      newCreated,
    });
  }
}


// 获取产品功能点列表
export function getFeatureListByProductId(productId, callback, failCallback) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    // const { firmwareUpgradeCode, productId } = productDetail;
    // const defaultParam = {
    //   offset: 0,
    //   limit: 100000,
    //   version: firmwareUpgradeCode,
    //   pid: productId,
    // };
    dispatch(updateLoadingStatus(true));
    const fetchData = new FetchData(`/iot/config/api/iot/support/product/feature/${productId || productDetail.productId}/page`, {
      method: "POST",
      // body: defaultParam,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        dispatch(updateLoadingStatus(false));
        let newData = {}
        if (data.data && data.data.customizeFeatures && data.data.templateFeatures) {
          const customizeFeatures = data.data.customizeFeatures.map(value => {
            let newValue = { ...value };
            //功能点中deName拆分出deNameCh和deNameEn
            newValue.deNameCh = util.parseJSON(value.deName).zh;
            newValue.deNameEn = util.parseJSON(value.deName).en;
            //isStandard为1代表自定义功能
            newValue.isStandard = 1;
            return newValue
          })
          const templateFeatures = data.data.templateFeatures.map(value => {
            let newValue = { ...value };
            //功能点中deName拆分出deNameCh和deNameEn
            newValue.deNameCh = util.parseJSON(value.deName).zh;
            newValue.deNameEn = util.parseJSON(value.deName).en;
            return newValue
          })
          newData = { customizeFeatures, templateFeatures }
        }
        if (data.code == '200') {
          dispatch({
            type: GET_FEATURES_LIST,
            featuresObj: newData || {},
            // total: data.data.totalResults
          });
          callback && callback();
        } else {
          failCallback && failCallback();
        }
      })
      .catch(e => {
        failCallback && failCallback();
        dispatch({
          type: GET_FEATURES_LIST,
          featuresObj: {},
          // total: data.data.totalResults
        });
        dispatch(updateLoadingStatus(false));
      });
  };
}

// 添加标准功能点到产品
export function updateFeatures(values, callback, failback) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { productId } = productDetail;
    //title值按{"zh":""}格式
    // let featureData = values.map(value => {
    //   let newData = {}
    //   newData.zh  = value.title || '';
    //   newData.en  = '';
    //   return {...value, title:JSON.stringify(newData)}
    // })
    const url = `/iot/config/api/iot/support/product/feature/${productId}/addPatch`;
    const fetchData = new FetchData(url, {
      method: 'POST',
      body: {
        featureDtos: values,
        pId: productId
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code === '200') {
          message.success(intl.get('commmon.operate.success'));
          dispatch(updateDomainModal(null, false));
          dispatch(getFeatureListByProductId());
          // 2021-01-05 功能点修改后，调用一次发布接口
          dispatch(publishProduct({ productId }))
        } else {
          message.error(data.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}

// 编辑功能点
export function editFeature(data) {
  return (dispatch, getState) => {
    dispatch(startFeatureEdit(data))
  };
}
// 删除功能点
export function deleteFeature(data) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { productId } = productDetail;
    const req = {
      id: data.id,
      featureType: data.featureType,
      productId,
    }
    const fetchData = new FetchData('/iot/config/api/iot/support/product/feature/delete',
      {
        method: "POST",
        body: req,
        metaHandler: {
          403: () => { window.location.href = '/authrization/login'; return; }
        },
      }
    );
    fetchData
      .then(data => {
        if (data.code === '200') {
          message.success(intl.get('commmon.operate.deleteSuccess'));
          dispatch(getFeatureListByProductId());
          // 2021-01-05 功能点修改后，调用一次发布接口
          dispatch(publishProduct({ productId }))
        } else {
          message.error(data.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}

// 按产品模板Id获取标准功能点列表
export function getFeatureByTemplateId(params = {}, callback, failCallback) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { isTemplate, category } = productDetail;
    // // 开发类型的产品不能添加标准功能点，可以自定义功能点  上个版本
    // if (isTemplate !== 1) {
    //   callback && callback();
    //   return;
    // }
    const defaultParam = {
      offset: 0,
      limit: 100000,
      category
    };
    const req = Object.assign({}, defaultParam, params);
    const fetchData = new FetchData(`/iot/config/api/iot/support/product/feature/template/page`, {
      method: "GET",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code === '200') {

          dispatch({
            type: GET_COMMON_DOMAIN_LIST,
            commonList: data.data || [],
          });
          callback && callback();
        } else {
          failCallback && failCallback();
        }
      })
      .catch(e => {
        failCallback && failCallback();
      });
  };
}

// 参数信息
export function setSingleParameter(data) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_SINGLE_PARAMETER,
      singleParameter: data,
    });
  }
}
